import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminFiberSettings } from '@/api/(admin)/fiber-settings';
import type { AdminFiberSetting } from '@/api/(admin)/fiber-settings/types';

/** Everything under this prefix — what the write path invalidates. */
export const adminFiberSettingsQueryKey = ['admin', 'fiber-settings'] as const;

/**
 * Shared by the route loader and the page, so the prefetch warms what the page
 * reads.
 *
 * No parameters: the route accepts none and returns every setting in one
 * response, which is why the table sorts and filters client-side and has no
 * pagination.
 */
export function adminFiberSettingsQueryOptions() {
  return queryOptions({
    queryKey: [...adminFiberSettingsQueryKey, 'list'] as const,
    queryFn: fetchAdminFiberSettings,
  });
}

export function useAdminFiberSettings() {
  const query = useQuery(adminFiberSettingsQueryOptions());

  const rows: AdminFiberSetting[] = query.data?.data ?? [];

  return { ...query, rows };
}
